import React, { useState } from 'react';
import {
  Button, Box, InputLabel, MenuItem, FormControl, FormControlLabel,
  FormLabel, Select, RadioGroup, Radio, Tooltip,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PropTypes from 'prop-types';
import DromoUpload from '../components/DromoUpload';

import logger from '../utils/logger';
import ImportHistory from '../components/client/ImportHistory';
import APIWrapper from '../utils/graphqlwrapper';
import { importExclusionsFields } from '../utils/dromoConstants';

function TransactionsExclusions(props) {
  const { client } = props;
  // for dromo upload
  const [transactionsPlatform, setTransactionsPlatform] = useState('actblue');
  const [excludeFlag, setExcludeFlag] = useState(true);
  const [importedNewData, setImportedNewData] = useState(false);
  const [isImporterOpen, setIsImporterOpen] = useState(false);

  const handleOpenDromo = () => {
    // open dromo uploader
    setIsImporterOpen(true);
  };

  const handlePlatformChange = (event) => {
    setTransactionsPlatform(event.target.value);
  };

  const handleExcludeFlagChange = (event) => {
    setExcludeFlag(event.target.value === 'true');
  };

  const handleUpload = async (metadata) => {
    /**
     * Triggers the importExclusionHistoryTrigger lambda function through appsync
     * The lambda will update transactions based on the exclusion flag
     * It will also update the ImportHistory dynamodb table
    */
    const stringifiedMetadata = JSON.stringify(metadata);
    try {
      await APIWrapper.queryApi(
        { query: 'importExclusionHistoryTrigger' },
        false,
        { metadata: stringifiedMetadata, excluding: excludeFlag },
      );
    } catch (err) {
      logger.error(err);
    }
    // set state to update table data
    setImportedNewData(true);
  };

  const handleRefreshHandled = () => {
    // used to reset state after user uploads a file
    // and Import History table gets refreshed
    setImportedNewData(false);
  };

  return (
    <div>
      <Box
        sx={{ mb: 1 }}
      >
        <div className="import-options">
          <div className="exclude-flag-group">
            <FormControl
              sx={{ mx: 1 }}
              focused={false}
            >
              <FormLabel id="exclude-flag-label">
                Exclude Flag
                <Tooltip title="Select whether to exclude or unexclude transactions in this file">
                  <HelpOutlineIcon fontSize="small" />
                </Tooltip>
              </FormLabel>
              <RadioGroup defaultValue="true" aria-label="exclude-flag" name="exclude-flag" onChange={handleExcludeFlagChange}>
                <FormControlLabel
                  value="true"
                  name="exclude-flag-true"
                  control={<Radio />}
                  label="True"
                />
                <FormControlLabel
                  value="false"
                  name="exclude-flag-false"
                  control={<Radio />}
                  label="False"
                />
              </RadioGroup>
            </FormControl>
          </div>

          <FormControl
            sx={{ mx: 1 }}
            style={{ minWidth: 200 }}
          >
            <InputLabel id="transaction-platform-select">Donation Platform</InputLabel>
            <Select
              labelId="transactions-platform-label"
              id="transaction-platform-select"
              value={transactionsPlatform}
              label="Donation Platform"
              onChange={handlePlatformChange}
            >
              <MenuItem value="actblue">Actblue</MenuItem>
              <MenuItem value="actionkit">Actionkit</MenuItem>
              <MenuItem value="bigquery">Bigquery</MenuItem>
              <MenuItem value="bsd">BSD</MenuItem>
              <MenuItem value="civis">Civis</MenuItem>
              <MenuItem value="cheetahmail">Cheetahmail</MenuItem>
              <MenuItem value="classy">Classy</MenuItem>
              <MenuItem value="custom">Custom</MenuItem>
              <MenuItem value="engaging_networks">Engaging Networks</MenuItem>
              <MenuItem value="flat_file">Flat File</MenuItem>
              <MenuItem value="funraise">Funraise</MenuItem>
              <MenuItem value="fundraise_up">Fundraise Up</MenuItem>
              <MenuItem value="hub">Hub</MenuItem>
              <MenuItem value="kindest">Kindest</MenuItem>
              <MenuItem value="luminate">Luminate</MenuItem>
              <MenuItem value="ngp_everyaction">NGP</MenuItem>
              <MenuItem value="raisers_edge">Raisers Edge</MenuItem>
              <MenuItem value="salesforce">Salesforce</MenuItem>
              <MenuItem value="salsa">Salsa</MenuItem>
              <MenuItem value="salsa_engage">Salsa Engage</MenuItem>
            </Select>
          </FormControl>
        </div>
        <Button onClick={handleOpenDromo} variant="contained">UPLOAD EXCLUSIONS FILE</Button>
        <DromoUpload
          isImporterOpen={isImporterOpen}
          setIsImporterOpen={setIsImporterOpen}
          importFields={importExclusionsFields}
          importIdentifier={`Transaction Bulk ${excludeFlag === true ? 'Exclusions' : 'Unexclusions'}`}
          allowCustomFields={false}
          userObject={{
            id: client,
            companyName: transactionsPlatform,
          }}
          bulkRowHooks={[
            // handle exclude flag and pass value according to user selection
            (records) => records.map((record) => {
              const newRecord = record;

              newRecord.row.exclude_flag = { value: excludeFlag };
              newRecord.row.exclude_flag.info = [
                {
                  message: `Exclude Flag set to ${excludeFlag}`,
                  level: 'info',
                },
              ];
              return newRecord;
            }),
          ]}
          handleUpload={handleUpload}
        />
      </Box>
      <Box
        sx={{ mt: 3 }}
      >
        <ImportHistory
          client={client}
          importedNewData={importedNewData}
          handleRefreshHandled={handleRefreshHandled}
          type="exclusions_upload"
        />
      </Box>
    </div>
  );
}

export default TransactionsExclusions;

TransactionsExclusions.propTypes = {
  client: PropTypes.string,
};
